import PropTypes from "prop-types";
import OutreachTabGroup from "../components/outreach-tab-group";
import OutreachDraftCard from "../components/outreach-draft-card";
import { useState } from "react";

const OutreachEmailComponent = ({ drafts }) => {
  const [activeTab, setActiveTab] = useState("Drafts");

  return (
    <>
      <OutreachTabGroup activeTab={activeTab} onTabChange={setActiveTab} draftsCount={drafts.length} />

      <div className="outreach-drafts-container">
        {activeTab === "Drafts" && (
          <div className="outreach-drafts-heading">
            <h2>
              {" "}
              <strong>{drafts.length} Drafts</strong>
            </h2>
            {drafts.map((draft) => (
              <OutreachDraftCard key={draft.id} draft={draft} />
            ))}
          </div>
        )}
        {activeTab === "Scheduled"}
        {activeTab === "Sent"}
      </div>
    </>
  );
};

OutreachEmailComponent.propTypes = {
  drafts: PropTypes.array.isRequired,
};

export default OutreachEmailComponent;
